import React from 'react'

const MiniTimer = ({ minutes, seconds, title='Certificate Saved For:' }) => {
    return (
        <div className='flex items-center justify-center text-white gap-2 mb-1.5'>
            <p className='text-xs font-medium'>{title}</p>
            <div className='border border-slider-red text-slider-red flex rounded justify-center py-0.5 px-1'>
                <p className='text-[11px] font-extrabold'>{minutes.toString().padStart(2, '0')}M :</p>
                <p className='text-[11px] font-extrabold ml-1'>{seconds.toString().padStart(2, '0')}S</p>
            </div>
        </div>
    )
}

export default MiniTimer